module.exports = __webpack_public_path__ + "23d9855bac83205ca655b8eaec32d69e.png";